import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { MrfiktivPageFilterElementGen } from "@/services/mrfiktiv/v1/data-contracts";

class PageFilterElementBase implements MrfiktivPageFilterElementGen {
  key: string;
  operation?: PageFilterOperationEnum;
  value: string;

  constructor(filter?: Partial<MrfiktivPageFilterElementGen>) {
    this.key = filter?.key ?? "";
    this.operation = filter?.operation as PageFilterOperationEnum;
    this.value = filter?.value ?? "";
  }
}

type IPageFilterElement = PageFilterElementBase;
const PageFilterElement = PageFilterElementBase;

export { IPageFilterElement, PageFilterElement };
